import { genera_captcha_url } from "./urlBase"
// import { client } from "./apiCall";

const generaCaptcha = async () => {

    try {
        // const request = client(null)
        // const resp = await request.call('GET', genera_captcha_url, null)

        // //const resp = await apiCall( 'GET', genera_captcha_url, null )
        // const response = resp.data


        const resp = await fetch( genera_captcha_url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                        'Access-Control-Allow-Origin': "*" }
        })
        const response = await resp.json()

        if ( response.Success ) {
            return response.Data
        }
        else {
            console.log('captchaHelper', '14')
            throw response
        }

    } catch ( e ) {
        console.log(e)
        console.log('captchaHelper', '20')
        throw e
    }
}

export {
    generaCaptcha
}